import { View } from 'react-native'
import { Button } from '../../../../../../components/Button'
import { lightBlue } from '../../../../../../theme/colors'
import { useTranslation } from 'react-i18next'

interface Props {
  onSave: () => void
  onAddPhoto: () => void
}

export const ActionsButtons = ({ onAddPhoto, onSave }: Props) => {
  const { t } = useTranslation()
  return (
    <View
      style={{
        flexDirection: 'row',
        marginBottom: 24,
        paddingHorizontal: 24,
        justifyContent: 'space-between',
      }}
    >
      <Button
        label={t('Foto adicional')}
        onPress={onAddPhoto}
        customStyle={{ flex: 1, marginRight: 5, backgroundColor: lightBlue }}
      />
      <Button label={t('Guardar')} onPress={onSave} customStyle={{ flex: 1, marginLeft: 5 }} />
    </View>
  )
}
